import { Button, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IPageButton {
  pageNumber: number;
  isActivePage?: boolean;
  setCurrentPage: Function;
}

export const PageButton = ({
  pageNumber,
  isActivePage,
  setCurrentPage,
}: IPageButton) => {
  const isDesktop = useIsDesktop();

  const paginateToHandler = () => {
    setCurrentPage(pageNumber);
    window.scroll({ behavior: 'smooth', top: 0 });
  };

  return (
    <Button
      sx={{
        p: 0,
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: isDesktop ? '10px' : '6px',
        bgcolor: isActivePage ? 'primary.main' : '#FFF',
        color: isActivePage ? '#FFF' : 'primary.main',
        minWidth: 0,
        minHeight: 0,
        width: isDesktop ? '35px' : '27px',
        height: isDesktop ? '35px' : '27px',
      }}
      onClick={paginateToHandler}
    >
      <Typography variant='body4'>{pageNumber + 1}</Typography>
    </Button>
  );
};
